
















import { Component, Vue, Prop, Provide, Emit, Watch } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class NetsTab extends Vue {
  @Prop() public site!: any
  @Prop() public clean!: boolean
  @Prop() public nets!: any
  public data = [[1, '17题库'], [2, '菁优网'], [3, '学科网']]
  public currentNet = [1, '17题库']
  @Watch('nets', { deep: true, immediate: true })
  onNetsChange(val) {
    if (val && val.length > 0) {
      this.data = val
      this.currentNet = this.data[0]
    }
  }
  @Watch('site', { deep: true })
  onSiteChange(val) {
    this.currentNet = val
  }
  @Watch('clean')
  onCleanChange(val: boolean) {
    this.currentNet = this.data[0]
  }
  @Emit()
  /**
   * onSelect
   */
  public onSelect(val) {
    return val
  }
  /**
   * select
   */
  public select(item) {
    this.currentNet = item
    this.onSelect(this.currentNet)
  }
}
